import {DocumentNode, gql} from "@apollo/client";

export const PROFILE_QUERY: DocumentNode = gql(`    
    query GetProfile {
      getProfile {
        ...UserInfo
      }
    }
`);
